import { render, staticRenderFns } from "./configuracao-notificacao-perfil.vue?vue&type=template&id=014ee90c&scoped=true"
import script from "./configuracao-notificacao-perfil.vue?vue&type=script&lang=ts"
export * from "./configuracao-notificacao-perfil.vue?vue&type=script&lang=ts"
import style0 from "./configuracao-notificacao-perfil.vue?vue&type=style&index=0&id=014ee90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ee90c",
  null
  
)

export default component.exports